<template>
  <div class="space-y-2">
    <h2 class="text-text-neutral-primary text-base font-medium">
      {{ $t('main.blog.title') }}
    </h2>
    <div v-if="isLoading" class="shimmer h-[244px] w-full rounded-2xl"></div>
    <button
      v-else
      type="button"
      class="text-static-white relative flex min-h-60 w-full flex-col items-start rounded-2xl p-4"
      @click="navigateToArticle"
    >
      <img
        class="absolute inset-0 h-full w-full rounded-2xl object-cover brightness-50"
        :src="details.preview_image"
        alt=""
        role="presentation"
      />
      <span
        class="relative z-10 flex h-full w-full flex-col justify-between space-y-24"
      >
        <span class="flex items-center space-x-3 text-left">
          <span class="flex items-center space-x-1">
            <img
              src="./assets/clock.svg"
              width="16"
              height="16"
              role="presentation"
              alt=""
            />
            <span class="text-xs font-medium">
              {{
                $t('main.blog.readInMins', {
                  count: Math.round(details.read_time_minutes),
                })
              }}
            </span>
          </span>
          <span v-if="details.views" class="flex items-center space-x-1">
            <img
              src="./assets/eye.svg"
              width="16"
              height="16"
              role="presentation"
              alt=""
            />
            <span class="text-xs font-medium">{{ details.views }}</span>
          </span>
        </span>
        <span class="flex flex-col items-start space-y-4 text-left">
          <span class="flex flex-col items-start space-y-1">
            <span class="text-lg font-bold">{{ details.title }}</span>
            <span class="text-sm">{{ details.subtitle }}</span>
          </span>
          <span
            class="text-text-neutral-secondary bg-background-neutral-secondary flex items-center space-x-1 rounded-2xl px-3 py-2 text-xs font-medium"
          >
            <span>
              {{ $t('main.blog.read') }}
            </span>
            <span> → </span>
          </span>
        </span>
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
  import type { blog } from 'shared';
  import { appLocale } from 'shared';
  import { amplitudeLib } from 'freedom-shared';

  defineProps<{
    details: blog.types.BlogArticle;
    isLoading?: boolean;
  }>();
  const emit = defineEmits<{
    onNavigateToArticle: [];
  }>();

  const isKKLocale =
    appLocale.lib.getAppLocale() === appLocale.config.locales.KK;
  const isRULocale =
    appLocale.lib.getAppLocale() === appLocale.config.locales.RU;

  async function navigateToArticle() {
    emit('onNavigateToArticle');

    let baseUrl = '';
    if (isKKLocale) {
      baseUrl = import.meta.env.VITE_BLOG_KK_ARTICLE_URL;
    } else if (isRULocale) {
      baseUrl = import.meta.env.VITE_BLOG_RU_ARTICLE_URL;
    } else {
      baseUrl = import.meta.env.VITE_BLOG_EN_ARTICLE_URL;
    }

    const theme = localStorage.getItem('theme') || 'light';

    const url = baseUrl.includes('?')
      ? `${baseUrl}&isFullScreen=true&theme=${theme}`
      : `${baseUrl}?isFullScreen=true&theme=${theme}`;

    await amplitudeLib.flushEvents();

    window.location.href = url;
  }
</script>
